let instances
let animationFrame

export function ScrollUp() {
    let els = document.querySelectorAll('[data-scroll-up]')
    if (!els.length) {
        return
    }

    instances = Array.from(els).map((el) => {
        return {
            el,
            top: el.offsetTop
        }
    })

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
}

function handleResize() {
    for (let i = 0; i < instances.length; i++) {
        instances[i].top = instances[i].el.offsetTop
    }
}

function handleScroll() {
    if (animationFrame) {
        return
    }

    animationFrame = requestAnimationFrame(() => {
        let currentScroll = window.scrollY

        instances.forEach((instance) => {
            if (currentScroll < instance.top - window.innerHeight) {
                instance.progress = 0
            } else if (currentScroll > instance.top) {
                instance.progress = 1
            } else {
                instance.progress = 1 - (instance.top - currentScroll) / window.innerHeight
            }

            instance.el.style.setProperty('--scroll-up', instance.progress)
        })

        animationFrame = null
    })
}
